<template>
  <div class="registration">
    <div class="title-section">
      <h1 class="page-title">{{ $props.pageTitle }}</h1>
      <p class="page-subtitle">{{ $props.pageSubtitle }}</p>
    </div>
    <registration-form/>
  </div>
</template>

<script>
import RegistrationForm from '@/components/registration/registration-form'
import { addDataLayerEvent } from '@/services/dataLayer'

export default {
  name: 'page-user-registration',
  components: { RegistrationForm },
  props: {
    pageTitle: String,
    pageSubtitle: String
  },
  mounted () {
    addDataLayerEvent({
      event: 'screen',
      name: 'register_account'
    })
  }
}
</script>

<style scoped lang="scss">
.registration {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  min-height: calc(100vh - 68px);
}
</style>
